// extracted by mini-css-extract-plugin
module.exports = {"btn":"index-module_btn_1XrwI","p-no":"index-module_p-no_2dYCG","contain":"index-module_contain_16eDd","title-p":"index-module_title-p_Uha8H"};